import { useEffect, useMemo, useState } from "react";
import { classNames } from "primereact/utils";
import localeText from "../../../../../locale";
import BannerCarousel from "../../../../Shop/components/BannerCarousel/BannerCarousel";
import SubBannerCarousel from "../../../../Shop/components/BestDeals/SubBannerCarousel/SubBannerCarousel";
import placeholderImg from "../../../../images/pages/ad-banner1.png";
import { DEVICES, LANGS, slotField } from "../bannerModel";

const PLACEHOLDER = [{ id: "placeholder", bgImg: placeholderImg }];
const SUB_TYPES = ["sub1", "sub2", "sub3"];

// Prévia com os carrosséis reais da loja, por idioma e dispositivo
const BannerPreview = ({ type, banners, delay }) => {
  const [lang, setLang] = useState(LANGS[0].code);
  const [device, setDevice] = useState(DEVICES[0].key);

  const field = slotField(device, lang);

  // Imagens novas (File) viram URLs temporárias, liberadas quando a prévia muda
  const { items, urls } = useMemo(() => {
    const created = [];
    const list = banners
      .map((banner, index) => {
        const value = banner.images[field];
        if (!value) return null;
        if (value instanceof File) {
          const url = URL.createObjectURL(value);
          created.push(url);
          return { id: index, bgImg: url, urlDestination: banner.urlDestination };
        }
        return { id: index, bgImg: value, cloudinary: true, urlDestination: banner.urlDestination };
      })
      .filter(Boolean);
    return { items: list, urls: created };
  }, [banners, field]);

  useEffect(() => () => urls.forEach((url) => URL.revokeObjectURL(url)), [urls]);

  const isMain = type === "main";

  return (
    <section className="admin-banner-preview">
      <header className="admin-banner-preview__header">
        <h3 className="admin-banner-card__title">{localeText("adminBannersPreview")}</h3>
        <div className="admin-banner-preview__controls">
          <div className="admin-home-period__segmented" role="group" aria-label={localeText("language")}>
            {LANGS.map((item) => (
              <button
                key={item.code}
                type="button"
                className={classNames("admin-home-period__option", {
                  "admin-home-period__option--active": lang === item.code,
                })}
                aria-pressed={lang === item.code}
                onClick={() => setLang(item.code)}
              >
                {item.code.toUpperCase()}
              </button>
            ))}
          </div>
          <div className="admin-home-period__segmented" role="group">
            {DEVICES.map((item) => (
              <button
                key={item.key}
                type="button"
                className={classNames("admin-home-period__option", {
                  "admin-home-period__option--active": device === item.key,
                })}
                aria-pressed={device === item.key}
                onClick={() => setDevice(item.key)}
              >
                <i className={item.key === "desktop" ? "pi pi-desktop" : "pi pi-mobile"} aria-hidden="true" />{" "}
                {localeText(item.key === "desktop" ? "adminBannersDesktop" : "adminBannersMobile")}
              </button>
            ))}
          </div>
        </div>
      </header>

      <div
        className={classNames("admin-banner-preview__stage", {
          "admin-banner-preview__stage--mobile": device === "mobile",
        })}
      >
        {items.length === 0 ? (
          <p className="admin-muted">{localeText("dontHaveImage")}</p>
        ) : isMain ? (
          <BannerCarousel key={field} items={items} timeToChangeImg={delay} />
        ) : (
          <div className="admin-banner-preview__subs">
            {SUB_TYPES.map((subType) => (
              <SubBannerCarousel
                key={`${subType}-${field}`}
                items={subType === type ? items : PLACEHOLDER}
                timeToChangeImg={delay}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default BannerPreview;
